import React, { useState, useLayoutEffect } from 'react';
import NewTenantAdded from './new_tenant_added.js.jsx';

const NewTenantForm = ({
  tenantTermOverride = 'Tenant',
  newTenantLightboxData = {},
}) => {
  const [tenantContainers, setTenantContainers] = useState([{ id: 0 }]);
  const [tenantCounter, setTenantCounter] = useState(1);
  useLayoutEffect(() => {
    const container = document.getElementById('tenant-box');
    window.mdc.autoInit(container);
    window.attachFormatMoneyListener();
    window.initDatepicker('#tenant-box');
    window.initDateTimepicker('#tenant-box');
    window.initSelect2('#tenant-box');
  }, []);

  const handleAddTenant = () => {
    const newTenantIndex = tenantCounter;
    setTenantContainers((prev) => [...prev, { id: newTenantIndex }]);
    setTenantCounter((prev) => prev + 1);

    const deleteBtn = document.getElementById('delete-tenant');
    if (deleteBtn && tenantContainers.length >= 1) {
      deleteBtn.style.display = 'block';
    }
  };

  const handleDeleteTenant = (tenantId) => {
    if (tenantContainers.length > 1) {
      setTenantContainers((prev) =>
        prev.filter((container) => container.id !== tenantId)
      );

      const deleteBtn = document.getElementById('delete-tenant');
      if (deleteBtn && tenantContainers.length <= 2) {
        deleteBtn.style.display = 'none';
      }
    }
  };

  return (
    <div id="tenant-box">
      {tenantContainers.map((container, index) => (
        <div key={container.id} id={`new-tenant-container-${container.id}`}>
          <NewTenantAdded
            {...newTenantLightboxData}
            tenantIndex={container.id}
            tenantDisplayNumber={index + 1}
            onDelete={
              container.id > 0 ? () => handleDeleteTenant(container.id) : null
            }
          />
        </div>
      ))}
      <button
        type="button"
        className="mdc-button pm-text-color--white pm-bg-color--green1"
        id="new-tenant-btn"
        data-mdc-auto-init="MDCRipple"
        onClick={handleAddTenant}
      >
        Add {tenantTermOverride.toLowerCase()}
      </button>
    </div>
  );
};

export default NewTenantForm;
